/*
 * Copyright (c) 2021-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';

import PropTypes from 'prop-types';
import {Transition} from 'react-transition-group';
import {Popper} from "react-popper";
import DisplayIcon from "../Icons/DisplayIcon.jsx";
import GlobalPortal from "../GlobalPortal.jsx";


class DropdownComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <GlobalPortal>
                <Transition in={this.props.isOpen} mountOnEnter={true} unmountOnExit={true}
                            timeout={20}>
                    {state => (
                        <Popper placement="bottom-start"
                                referenceElement={document.querySelector(this.props.querySelector)}
                                modifiers={[
                                    {
                                        name: 'preventOverflow',
                                        options: {
                                            boundary: document.querySelector('#root'),
                                        },
                                    },
                                    {
                                        name: 'flip',
                                        options: {
                                            fallbackPlacements: ['top-start', 'top-end', 'bottom-end'],
                                            rootBoundary: 'document',
                                            boundary: document.querySelector('#root'),

                                        },
                                    }, {
                                        name: "offset",
                                        enabled: true,
                                        options: {
                                            offset: ({placement, reference, popper}) => {
                                                switch (placement) {
                                                    case 'top-end':
                                                    case 'top-start':
                                                    case 'top':
                                                    default:
                                                        return [0, 1]


                                                }
                                            },
                                        }
                                    }
                                ]}>
                            {({ref, style, placement, arrowProps}) => (
                                <div ref={ref}
                                     style={{...style, ...{width: "230px", height: "133px", zIndex: 999}}}
                                     data-placement={placement}

                                >

                                    {/*
    Dropdown menu, show/hide based on menu state.

    Entering: "transition ease-out duration-100"
From: "transform opacity-0 scale-95"
To: "transform opacity-100 scale-100"
    Leaving: "transition ease-in duration-75"
From: "transform opacity-100 scale-100"
To: "transform opacity-0 scale-95"
  */}
                                    <div
                                        tabIndex={100}
                                        onBlur={() => {
                                            setTimeout(() => {
                                                if (this.props.close !== undefined) {
                                                    this.props.close()

                                                }

                                            }, 400)
                                        }}
                                        className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                                        role="menu" aria-orientation="vertical" aria-labelledby="menu-button">
                                        <div className="p-1.5" role="none">
                                            {this.props.content.map(element => {
                                                return (<div
                                                    key={element.id} onMouseDown={element.onClick}
                                                    className="text-gray-700 group flex items-center px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 rounded select-none hover:text-blue-500"
                                                    role="menuitem" tabIndex={-1}>
                                                    <DisplayIcon iconName={element.iconName}
                                                                 className={"mr-3 h-5 w-5 "}/>

                                                    {element.text}
                                                </div>)

                                            })}


                                        </div>

                                    </div>


                                    {/*<div className="relativ">*/}
                                    {/*    <div style={{*/}
                                    {/*        ...defaultStyle,*/}
                                    {/*        ...transitionStyles[state]*/}
                                    {/*    }}*/}
                                    {/*         className="border border-gray-300 rounded-b bg-white  absolute t-0 l-0 z-100 rounded-lg shadow-xl transition-all duration-150">*/}
                                    {/*        <div*/}
                                    {/*            className="inline-block align-bottom bg-white  text-left overflow-hidden w-full h-full flex flex-col ">*/}
                                    {/*            <div className="bg-white pr-2 pb-1 flex-grow">*/}
                                    {/*                <div className="sm:flex sm:items-start">*/}

                                    {/*                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">*/}
                                    {/*                        <div className="mt-2">*/}
                                    {/*                            <p className="text-sm text-gray-500 max-h-16 overflow-ellipsis overflow-hidden">*/}
                                    {/*                                {this.props.text}*/}
                                    {/*                            </p>*/}
                                    {/*                        </div>*/}
                                    {/*                    </div>*/}
                                    {/*                </div>*/}
                                    {/*            </div>*/}
                                    {/*            <div*/}
                                    {/*                className="bg-gray-50 px-3 py-3 h-14 ">*/}
                                    {/*                {this.props.children}*/}
                                    {/*            </div>*/}

                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}


                                </div>)}
                        </Popper>
                    )}
                </Transition>
            </GlobalPortal>
        )

    };
}

export default DropdownComponent;

DropdownComponent.propTypes = {
    /**
     * Bool value to open the panel
     * @default false
     */
    isOpen: PropTypes.bool,

    text: PropTypes.string,
    onButtonClick: PropTypes.func,

}

DropdownComponent.defaultProps = {
    text: 'Small dialog text',
    isOpen: false,
}